module.exports = __webpack_public_path__ + "static/media/sivan-fm.05242e83.png";